





























































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import SearchBar from '@/components/SearchBar.vue';
import APIKeyList from '@/components/APIKeyList.vue';
import UserEdit from '@/components/UserEdit.vue';
import { Getter } from 'vuex-class';
import UserService from '@/services/user.service';
import { Role, User } from '../../types';
import Dialog from '@/components/Dialog.vue';
import GenericButton from '@/components/GenericButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';

@Component({
  components: {
    ConfirmButton,
    CancelButton,
    GenericButton,
    Dialog,
    SearchBar,
    APIKeyList,
    UserEdit,
  },
})
export default class APIKeys extends Vue {
  public user: User | null = null;
  @Prop() private bus!: any;
  @Getter private roles?: Role[];
  @Getter private hasPermission: any;

  private name: string = '';
  private showApiKeyDialog: boolean = false;
  private rolesSelected: number[] = [];
  private loading: boolean = false;

  private async mounted() {
    await this.$store.dispatch('addRolesAsync');
  }

  private async addApiKey() {
    this.loading = true;

    try {
      await UserService.createApiUser(this.name, this.rolesSelected);
      this.$emit('user', this.user);
      if (this.$refs.apiKeyList) {
        await (this.$refs.apiKeyList as APIKeyList).getApiUsers();
      }

      this.showApiKeyDialog = false;
    } finally {
      this.loading = false;
    }
  }

  private async showModal() {
    this.name = '';
    this.rolesSelected = [];
    this.showApiKeyDialog = true;
  }

  private getColor(role: any) {
    switch (role) {
      case 'Super Admin': return 'rgba(1,110,161,0.6)';
      case 'Organisation Admin': return '#016EA1';
      case 'User': return 'rgba(1,110,161,0.4)';
      default: return 'primary';
    }
  }
}
